<template>
  <LoadingView :loading="false">
    <Head :title="__('Forgot Password')" />

    <form
      class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[25rem] mx-auto"
      @submit.prevent="attempt"
    >
      <h2 class="text-2xl text-center font-normal mb-6">
        {{ __('Forgot your password?') }}
      </h2>

      <div class="mb-6">
        <label
          class="block mb-2"
          for="email"
        >{{ __('Email Address') }}</label>
        <input
          id="email"
          v-model="form.email"
          class="form-control form-input form-control-bordered w-full"
          :class="{ 'form-control-bordered-error': form.errors.has('email') }"
          type="email"
          name="email"
          required=""
          autofocus=""
        >

        <HelpText
          v-if="form.errors.has('email')"
          class="mt-2 text-red-500"
        >
          {{ form.errors.first('email') }}
        </HelpText>
      </div>

      <Button
        class="w-full flex justify-center"
        type="submit"
        :loading="form.processing"
      >
        {{ __('Send Password Reset Link') }}
      </Button>
      <DividerLine />
      <div class="flex justify-center">
        <Link
          :href="$url('/login')"
          class="text-gray-500 font-bold no-underline pl-2"
        >
          {{ __('Back to login') }}
        </Link>
      </div>
    </form>
  </LoadingView>
</template>

<script>
import Auth from '@/layouts/Auth'
import { Button } from 'laravel-nova-ui'

export default {

  components: {
    Button,
  },

  layout: Auth,

  data: () => ({
    form: Nova.form({
      email: '',
    }),
  }),

  computed: {
    supportsPasswordReset() {
      return Nova.config('withPasswordReset')
    },

    forgotPasswordPath() {
      return Nova.config('forgotPasswordPath')
    },
  },

  methods: {
    async attempt() {
      const { message } = await this.form.post(Nova.url('/password/email'))

      Nova.$toasted.show(message, {
        action: {
          onClick: () => Nova.redirectToLogin(),
          text: this.__('Reload'),
        },
        duration: null,
        type: 'success',
      })

      setTimeout(() => Nova.redirectToLogin(), 5000)
    },
  },
}
</script>
